import { render, staticRenderFns } from "./signUpstudent.vue?vue&type=template&id=4fbac3fa&scoped=true"
import script from "./signUpstudent.vue?vue&type=script&scoped=true&lang=js"
export * from "./signUpstudent.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./signUpstudent.vue?vue&type=style&index=0&id=4fbac3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbac3fa",
  null
  
)

export default component.exports